
(function(){
  const STORE = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/';

  function money(cents, format){
    if(typeof cents === 'string') cents = cents.replace('.','');
    const value = Number(cents || 0) / 100;
    try{
      return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
        style:'currency',
        currency:(window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR'
      }).format(value);
    }catch(e){
      return '€' + value.toFixed(2).replace('.',',');
    }
  }

  function escapeHTML(str){
    const div=document.createElement('div');
    div.textContent=str == null ? '' : String(str);
    return div.innerHTML;
  }

  function debounce(fn, wait){
    let t;
    return function(){
      const args=arguments;
      clearTimeout(t);
      t=setTimeout(()=>fn.apply(this,args),wait);
    };
  }

  function init(root){
    if(!root || root.dataset.msdReady === 'true') return;
    root.dataset.msdReady='true';

    const drawer=root.querySelector('[data-msd-drawer]');
    const overlay=root.querySelector('[data-msd-overlay]');
    const closeBtn=root.querySelector('[data-msd-close]');
    const input=root.querySelector('[data-msd-input]');
    const form=root.querySelector('[data-msd-form]');
    const popular=root.querySelector('[data-msd-popular]');
    const featured=root.querySelector('[data-msd-featured]');
    const liveSection=root.querySelector('[data-msd-live-section]');
    const liveResults=root.querySelector('[data-msd-live-results]');
    const status=root.querySelector('[data-msd-status]');
    const footerLink=root.querySelector('[data-msd-footer-link]');
    const minChars=Number(root.dataset.minChars || 2);
    const limit=Number(root.dataset.limit || 6);
    let lastFocused=null;
    let controller=null;

    function openDrawer(){
      lastFocused=document.activeElement;
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';
      document.body.style.overflow='hidden';
      setTimeout(()=>input && input.focus(),220);
    }

    function closeDrawer(){
      overlay.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow='';
      document.body.style.overflow='';
      if(controller) controller.abort();
      if(lastFocused && typeof lastFocused.focus==='function') lastFocused.focus();
    }

    // Public event for custom triggers anywhere in theme.
    document.addEventListener('mialica:search:open', openDrawer);

    // Any element with this attribute can open the drawer.
    document.addEventListener('click', function(e){
      const trigger=e.target.closest('[data-mialica-search-open]');
      if(trigger){
        e.preventDefault();
        openDrawer();
      }
    });

    if(closeBtn) closeBtn.addEventListener('click',closeDrawer);
    if(overlay) overlay.addEventListener('click',closeDrawer);

    root.querySelectorAll('[data-msd-chip]').forEach(chip=>{
      chip.addEventListener('click',()=>{
        input.value=chip.dataset.query || chip.textContent.trim();
        input.dispatchEvent(new Event('input',{bubbles:true}));
        input.focus();
      });
    });

    function setStatus(html, show=true){
      if(!status) return;
      status.innerHTML=html;
      status.hidden=!show;
    }

    function resetToInitial(){
      if(popular) popular.hidden=false;
      if(featured) featured.hidden=false;
      if(liveSection) liveSection.hidden=true;
      if(liveResults) liveResults.innerHTML='';
      setStatus(root.dataset.hint || '', !!root.dataset.hint);
      if(footerLink) footerLink.href=root.dataset.searchUrl || '/search';
    }

    function renderProduct(product){
      const image = product.image || (product.featured_image && product.featured_image.url) || '';
      const imageHtml = image
        ? `<img src="${escapeHTML(image)}" alt="${escapeHTML(product.title)}" loading="lazy">`
        : `<div style="width:100%;height:100%;background:#f7edf0"></div>`;

      let type = product.type || product.vendor || '';
      const desc = product.body || product.description || '';
      const price = money(product.price);
      const compare = product.compare_at_price_min && Number(product.compare_at_price_min) > Number(product.price)
        ? `<s>${money(product.compare_at_price_min)}</s>` : '';

      return `
        <a class="msd-result" href="${escapeHTML(product.url)}">
          <div class="msd-result-image">${imageHtml}</div>
          <div class="msd-result-meta">
            ${type ? `<small>${escapeHTML(type)}</small>` : ''}
            <h4>${escapeHTML(product.title)}</h4>
            ${desc ? `<p>${escapeHTML(desc.replace(/<[^>]*>/g,'')).slice(0,150)}</p>` : ''}
          </div>
          <div class="msd-result-price">${price}${compare}</div>
        </a>`;
    }

    function renderSimple(item, label){
      return `
        <a class="msd-result" href="${escapeHTML(item.url)}">
          <div class="msd-result-image"><div style="width:100%;height:100%;background:#f7edf0"></div></div>
          <div class="msd-result-meta">
            <small>${escapeHTML(label)}</small>
            <h4>${escapeHTML(item.title)}</h4>
            ${item.body ? `<p>${escapeHTML(item.body.replace(/<[^>]*>/g,'')).slice(0,150)}</p>` : ''}
          </div>
          <div class="msd-result-price">→</div>
        </a>`;
    }

    async function predictiveSearch(query){
      if(controller) controller.abort();
      controller=new AbortController();

      if(query.length < minChars){
        resetToInitial();
        return;
      }

      if(popular) popular.hidden=true;
      if(featured) featured.hidden=true;
      if(liveSection) liveSection.hidden=false;
      if(liveResults) liveResults.innerHTML='';
      setStatus(`<span class="msd-loader"></span>${escapeHTML(root.dataset.loading || 'Ricerca in corso…')}`,true);

      const url = `${STORE}search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=${limit}&resources[options][unavailable_products]=hide`;

      try{
        const res=await fetch(url,{
          headers:{'Accept':'application/json'},
          signal:controller.signal
        });
        if(!res.ok) throw new Error('Predictive search failed');
        const data=await res.json();
        const results=(data.resources && data.resources.results) ? data.resources.results : {};
        const products=(results.products || []).filter(p=>!((p.tags||[]).indexOf('hide-from-catalog')>-1));
        const pages=results.pages || [];
        const articles=results.articles || [];

        let html='';
        products.forEach(p=>html+=renderProduct(p));
        pages.forEach(p=>html+=renderSimple(p,root.dataset.pageLabel || 'Pagina'));
        articles.forEach(a=>html+=renderSimple(a,root.dataset.articleLabel || 'Journal'));

        if(html){
          liveResults.innerHTML=html;
          setStatus('',false);
        }else{
          liveResults.innerHTML='';
          setStatus(escapeHTML(root.dataset.noResults || 'Nessun risultato trovato.'),true);
        }

        if(footerLink){
          footerLink.href=(root.dataset.searchUrl || '/search')+'?q='+encodeURIComponent(query);
        }
      }catch(err){
        if(err.name==='AbortError') return;
        setStatus(escapeHTML(root.dataset.error || 'Impossibile caricare i suggerimenti. Premi Invio per la ricerca completa.'),true);
        if(footerLink){
          footerLink.href=(root.dataset.searchUrl || '/search')+'?q='+encodeURIComponent(query);
        }
      }
    }

    if(input){
      input.addEventListener('input',debounce(function(){
        predictiveSearch(input.value.trim());
      },220));
    }

    if(form){
      form.addEventListener('submit',function(){
        // Native Shopify search form remains functional.
      });
    }

    root.addEventListener('keydown',function(e){
      if(e.key==='Escape' && drawer.classList.contains('is-open')){
        e.preventDefault();
        closeDrawer();
        return;
      }

      if(e.key==='Tab' && drawer.classList.contains('is-open')){
        const focusables=[...drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
          .filter(el=>el.offsetParent!==null);
        if(!focusables.length) return;
        const first=focusables[0], last=focusables[focusables.length-1];
        if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
        else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
      }
    });

    resetToInitial();
  }

  document.addEventListener('DOMContentLoaded',()=>{
    document.querySelectorAll('.mialica-search-drawer').forEach(init);
  });

  document.addEventListener('shopify:section:load',e=>{
    const root=e.target.querySelector('.mialica-search-drawer') ||
      (e.target.matches && e.target.matches('.mialica-search-drawer') ? e.target : null);
    if(root) init(root);
  });
})();
